window.RENOVIIAX_PRODUCT_IMAGES = JSON.parse(document.getElementById('aeehfeng-live-product-images').textContent);



;

  const originalDescription=document.getElementById("originalDescription");
  window.RENOVIIAX_SOURCE_DESCRIPTION=originalDescription.innerHTML;
  const restoredMedia=originalDescription.querySelectorAll("img");
  restoredMedia.forEach(img=>{img.loading="lazy";img.decoding="async";});
  let originalHeadingCount=0;
  originalDescription.querySelectorAll("h2, h3, h4").forEach(h=>{if(h.querySelector("img"))h.classList.add("source-image-heading");else {h.classList.add("source-text-heading");originalHeadingCount++;if(originalHeadingCount%4===0)h.classList.add("chapter-dark");}});
  originalDescription.querySelectorAll("p").forEach(p=>{if(p.querySelector("img"))p.classList.add("source-image-paragraph");else if(p.textContent.trim().startsWith("\"") || p.textContent.trim().startsWith("“"))p.classList.add("source-review-paragraph");});
  // Recompose original nodes into compact editorial blocks without rewriting, cloning or deleting any source text, image or GIF.
  const isMeaningfulHeading=node=>node.nodeType===1 && node.matches('h2.source-text-heading,h3.source-text-heading,h4.source-text-heading') && node.textContent.trim().length>0;
  const hasVisibleBody=node=>node.nodeType===1 && !isMeaningfulHeading(node) && (node.querySelector('img') || node.textContent.trim().length>0);
  const sourceNodes=[...originalDescription.childNodes];
  const sections=[];let activeSection=[];
  for(const node of sourceNodes){
    if(isMeaningfulHeading(node)){
      const precedingHeadings=activeSection.filter(isMeaningfulHeading);
      const questionCluster=precedingHeadings.length>0 && precedingHeadings.every(h=>/^Are you worried/i.test(h.textContent.trim())) && /^Are you worried/i.test(node.textContent.trim());
      if(activeSection.some(hasVisibleBody) || (precedingHeadings.length>0 && !questionCluster)){sections.push(activeSection);activeSection=[];}
    }
    activeSection.push(node);
  }
  if(activeSection.length)sections.push(activeSection);
  let pairIndex=0;
  for(const [sectionIndex,nodes] of sections.entries()){
    const chapter=document.createElement('section');chapter.className='brand-chapter';
    const elements=nodes.filter(n=>n.nodeType===1);
    const sectionText=elements.map(e=>e.textContent||'').join(' ');
    const imageCount=elements.reduce((s,e)=>s+e.querySelectorAll('img').length+(e.matches('img')?1:0),0);
    const directMedia=elements.filter(e=>(e.matches('img') || e.querySelector('img')) && e.textContent.trim().length<5);
    const isReviews=sectionText.includes('Feedback from Real Users After Using the Product');
    if(sectionIndex===0 && imageCount>1)chapter.classList.add('brand-chapter--lead');
    if(isReviews){
      chapter.classList.add('brand-chapter--reviews');let reviewRow=null;
      for(const node of nodes){
        const imageOnly=node.nodeType===1 && (node.matches('img')||node.querySelector('img')) && node.textContent.trim().length<5;
        if(imageOnly){reviewRow=document.createElement('div');reviewRow.className='brand-review-row';chapter.appendChild(reviewRow);}
        const destination=reviewRow||chapter;
        if(node.nodeType===1 && reviewRow)node.classList.add(imageOnly?'chapter-media-node':'chapter-text-node');
        destination.appendChild(node);
      }
    } else {
      if(imageCount===1 && directMedia.length===1 && elements.some(e=>e.textContent.trim().length>28)){
        chapter.classList.add('brand-chapter--paired');if(pairIndex++%2)chapter.classList.add('is-reversed');
        directMedia[0].classList.add('chapter-media-node');
        elements.filter(e=>e!==directMedia[0]).forEach(e=>e.classList.add('chapter-text-node'));
      }else if(imageCount>1 && sectionIndex>0)chapter.classList.add('brand-chapter--rich');
      nodes.forEach(node=>chapter.appendChild(node));
    }
    originalDescription.appendChild(chapter);
  }
  // The merchant markup nests unrelated later chapters inside ingredient/usage list items.
  // Lift those original nodes in the same reading order, then give them separate layouts.
  // None of the original words, links, media or GIF files are rewritten or removed.
  const sourceTextBeforeLayout=originalDescription.textContent;
  const sourceMediaBeforeLayout=[...originalDescription.querySelectorAll('img')].map(img=>img.getAttribute('src'));
  const richChapter=originalDescription.querySelector('.brand-chapter--rich:last-child');
  if(richChapter){
    const richChildren=[...richChapter.children];
    const ingredientHeading=richChildren.find(el=>el.matches('h3.source-text-heading') && /6 Key Ingredients/i.test(el.textContent));
    const ingredientMedia=ingredientHeading?.nextElementSibling;
    const ingredientsHolder=richChildren.find(el=>el.querySelector(':scope > ul')?.children.length===6);
    const ingredientList=ingredientsHolder?.querySelector(':scope > ul');
    if(ingredientHeading && ingredientMedia?.querySelector('img')){
      const intro=document.createElement('div');intro.className='source-ingredient-intro';
      richChapter.insertBefore(intro,ingredientHeading);
      intro.appendChild(ingredientHeading);intro.appendChild(ingredientMedia);
    }
    if(ingredientList){
      ingredientsHolder.classList.add('source-ingredients-area');
      ingredientList.classList.add('source-ingredient-grid');
      const lastIngredient=ingredientList.lastElementChild;
      const originalChildren=[...lastIngredient.childNodes];
      const followupIndex=originalChildren.findIndex(node=>node.nodeType===1 && node.matches('h2,h3,h4'));
      if(followupIndex!==-1){
        const benefits=document.createElement('div');benefits.className='source-benefits-panel';
        ingredientList.after(benefits);
        originalChildren.slice(followupIndex).forEach(node=>benefits.appendChild(node));
      }
    }
    const usageHolder=[...richChapter.children].find(el=>el.querySelector(':scope > ol') && el.querySelector(':scope > h3.source-text-heading'));
    if(usageHolder){
      usageHolder.classList.add('source-rich-narrative');
      const initialSteps=usageHolder.querySelector(':scope > ol');
      const finalStep=initialSteps?.lastElementChild;
      if(finalStep){
        const originalChildren=[...finalStep.childNodes];
        const nextChapterIndex=originalChildren.findIndex(node=>isMeaningfulHeading(node));
        if(nextChapterIndex!==-1)originalChildren.slice(nextChapterIndex).forEach(node=>usageHolder.appendChild(node));
      }
      const units=[];let current=null;
      for(const node of [...usageHolder.childNodes]){
        const isFacts=node.nodeType===1 && node.matches('div') && !!node.querySelector(':scope > h2.source-text-heading');
        if(isMeaningfulHeading(node)||isFacts){
          if(current)units.push(current);
          current=document.createElement('section');current.className='source-nested-chapter';
          if(isFacts)current.classList.add('source-facts-panel');
          else if(/happy customers/i.test(node.textContent))current.classList.add('source-story-reviews');
          else current.classList.add('source-usage-card');
        }
        if(!current){current=document.createElement('section');current.className='source-nested-chapter source-usage-card';}
        if(isFacts){
          // Flatten the extra empty outer <div>; its inner section structure is preserved.
          [...node.childNodes].forEach(child=>current.appendChild(child));
          node.remove();
        }else current.appendChild(node);
      }
      if(current)units.push(current);
      units.forEach(unit=>usageHolder.appendChild(unit));
      units.filter(unit=>!unit.textContent.trim()&&!unit.querySelector('img')).forEach(unit=>unit.classList.add('source-empty-only'));
      const reviews=usageHolder.querySelector('.source-story-reviews');
      if(reviews){
        const pieces=[...reviews.childNodes];
        const reviewStart=pieces.findIndex(node=>node.nodeType===1&&node.matches('em')&&!!node.querySelector('img'));
        const secondImage=pieces.findIndex((node,index)=>index>reviewStart&&node.nodeType===1&&node.matches('p.source-image-paragraph'));
        if(reviewStart!==-1){
          const first=document.createElement('div');first.className='source-review-mini-card';
          reviews.insertBefore(first,pieces[reviewStart]);
          pieces.slice(reviewStart,secondImage===-1?undefined:secondImage).forEach(node=>first.appendChild(node));
        }
        if(secondImage!==-1){
          const second=document.createElement('div');second.className='source-review-mini-card';
          reviews.appendChild(second);
          pieces.slice(secondImage).forEach(node=>second.appendChild(node));
        }
      }
    }
    [...richChapter.children].filter(node=>!node.textContent.trim()&&!node.querySelector('img')).forEach(node=>node.classList.add('source-empty-only'));
  }
  const sourceMediaAfterLayout=[...originalDescription.querySelectorAll('img')].map(img=>img.getAttribute('src'));
  window.__sourceLayoutVerification={
    sameText:originalDescription.textContent.replace(/\s+/g,' ').trim()===sourceTextBeforeLayout.replace(/\s+/g,' ').trim(),
    sameMedia:JSON.stringify(sourceMediaAfterLayout)===JSON.stringify(sourceMediaBeforeLayout),
    descriptionImageCount:sourceMediaAfterLayout.length
  };
  originalDescription.dataset.sameOriginalText=String(window.__sourceLayoutVerification.sameText);
  originalDescription.dataset.sameOriginalMedia=String(window.__sourceLayoutVerification.sameMedia);
  if(!window.__sourceLayoutVerification.sameText||!window.__sourceLayoutVerification.sameMedia)console.error('Original text or media was changed by visual restructuring.');
  // Restore each original image in the redesigned story and complete, collapsible source archive.
  const sourcePictures=[...originalDescription.querySelectorAll('img')].map(img=>img.getAttribute('src'));
  document.querySelectorAll('[data-source-image]').forEach(el=>{
    const index=Number(el.dataset.sourceImage);
    if(sourcePictures[index])el.src=sourcePictures[index];
    else console.warn('Original source picture not found: '+index);
  });
  document.querySelectorAll('[data-gallery-image]').forEach(el=>{
    const index=Number(el.dataset.galleryImage);
    const src=window.RENOVIIAX_PRODUCT_IMAGES?.[index];
    if(src)el.src=src+'&width=900';
  });
  // Preserve the complete original content in styled source chapters.
  const sourceReviewChapter=originalDescription.querySelector('.brand-chapter--reviews');
  if(sourceReviewChapter){
    sourceReviewChapter.id='customerReviews';
    [...sourceReviewChapter.querySelectorAll('.brand-review-row')].forEach(row=>{
      const media=[...row.children].filter(el=>el.classList?.contains('chapter-media-node'));
      const other=[...row.children].filter(el=>!media.includes(el)&&el.textContent.trim());
      if(!other.length)return;
      const reviewCopy=document.createElement('div');reviewCopy.className='source-review-copy';
      other.forEach(el=>reviewCopy.appendChild(el));row.appendChild(reviewCopy);
      if(reviewCopy.textContent.trim().length>300){
        reviewCopy.classList.add('source-review-copy--clamped');
        const btn=document.createElement('button');btn.type='button';btn.className='source-review-toggle';btn.textContent='Read full review';
        btn.setAttribute('aria-expanded','false');
        btn.addEventListener('click',()=>{
          const expanded=reviewCopy.classList.toggle('source-review-copy--expanded');
          btn.textContent=expanded?'Show less':'Read full review';
          btn.setAttribute('aria-expanded',expanded?'true':'false');
        });
        row.appendChild(btn);
      }
    });
  }
  [...originalDescription.querySelectorAll('h2,h3,h4')].find(h=>/For radiant, lifted skin, follow these simple steps/i.test(h.textContent))?.setAttribute('id','ritualHowTo');
  const allProductVariants=JSON.parse(document.getElementById('aeehfeng-product-variants').textContent);
  const productInfo=JSON.parse(document.getElementById('aeehfeng-product-info').textContent);
  const numberKeys={1:'one',2:'two',4:'four',6:'six',10:'ten'},packs={};
  const jarBundles=allProductVariants.length>0&&allProductVariants.every(v=>/\*(1|2|4|6|10)$/.test(String(v.sku||'')));
  const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:productInfo.currency||'USD'}).format(n);
  allProductVariants.forEach(v=>{const match=String(v.sku||'').match(/\*(1|2|4|6|10)$/),n=jarBundles?Number(match[1]):1,key=jarBundles?numberKeys[n]:'variant-'+v.id;
    packs[key]={n,p:Number(v.price)/100,id:String(v.id),available:!!v.available,comparePrice:Number(v.compare_at_price||0)/100,label:v.title==='Default Title'?productInfo.title:v.title,generic:!jarBundles};
  });
  const baseSinglePrice=packs.one?.p||0;
  const $=id=>document.getElementById(id);
  if(!jarBundles){document.querySelectorAll('#aeehfeng-page .choice-list').forEach(list=>{const template=list.querySelector('.choice').cloneNode(true);list.replaceChildren();Object.entries(packs).forEach(([key,pack])=>{const choice=template.cloneNode(true);choice.dataset.key=key;choice.classList.remove('active');choice.setAttribute('aria-pressed','false');choice.querySelectorAll('.chip,.choice-feature-text,.choice-customer-share,.free-ship-tag,.choice-savings,.choice-shipping').forEach(el=>el.remove());choice.querySelector('.choice-main b').textContent=pack.label;choice.querySelector('.choice-main small').textContent=pack.available?'Available':'Sold out';choice.querySelector('.choice-price strong').textContent=money(pack.p);choice.querySelector('.choice-price small').textContent=productInfo.currency;const compare=choice.querySelector('.choice-compare');compare.hidden=pack.comparePrice<=pack.p;compare.replaceChildren();if(pack.comparePrice>pack.p){const del=document.createElement('del');del.textContent=money(pack.comparePrice);compare.append(del)}list.append(choice)})});document.querySelectorAll('.bundle-mix-note').forEach(el=>el.hidden=true);document.querySelector('#shop > .gallery-caption')?.setAttribute('hidden','');}
  else {document.querySelectorAll('#aeehfeng-page .choice').forEach(choice=>{const pack=packs[choice.dataset.key];if(!pack){choice.hidden=true;return}choice.querySelector('.choice-price strong').textContent=money(pack.p);const unit=choice.querySelector('.choice-price small');unit.textContent=productInfo.currency+' · '+money(pack.p/pack.n)+' / jar';const compare=choice.querySelector('.choice-compare');compare.replaceChildren();if(pack.n>1&&baseSinglePrice){compare.append('Regular single-jar total ');const del=document.createElement('del');del.textContent=money(pack.n*baseSinglePrice);compare.append(del)}else compare.textContent='Regular price '+money(pack.p);});}
  let selected=Object.keys(packs).find(key=>packs[key].id===String(productInfo.selected_variant_id))||Object.keys(packs).find(key=>packs[key].available)||Object.keys(packs)[0];
  function updatePack(key){
    selected=key;
    const p=packs[key];
    if(!p){console.warn('Aeehfeng: missing variant for package '+key);return;}
    const base=p.generic?Math.max(p.comparePrice,p.p):p.n*baseSinglePrice;
    const discount=base>p.p?Math.round((1-p.p/base)*100):0;
    const freeShipping=!p.generic&&p.n>=4;
    // Sync the selected jar bundle into this theme's original Shopify buy-buttons block.
    const variantInput=document.querySelector('#aeehfeng-shopify-purchase .product-variant-id');
    if(variantInput){
      variantInput.value=p.id;
      variantInput.disabled=(!p.available);
      variantInput.dispatchEvent(new Event('change',{bubbles:true}));
    }
    const nativeBuy=document.querySelector('#aeehfeng-shopify-purchase button[name="add"]');
    if(nativeBuy)nativeBuy.disabled=(!p.available);
    // The original theme handles payment button availability and plugin callbacks.
    const nativePrice=document.querySelector('#aeehfeng-shopify-purchase [id^="main-atc-price-"]');
    if(nativePrice && nativePrice.textContent.trim()!=='')nativePrice.textContent=money(p.p)+' • ';

    for(const c of document.querySelectorAll('.choice')){const on=c.dataset.key===key;c.classList.toggle('active',on);c.setAttribute('aria-pressed',on?'true':'false')}
    const qty=Math.max(1,Math.floor(Number($('aeehfeng-native-quantity')?.value)||1));
    $('selectedName').textContent=(p.generic?p.label:p.n+' '+(p.n===1?'Jar':'Jars'))+(qty>1?' × '+qty:'');
    $('selectedPrice').textContent=money(p.p*qty);
    $('stickyPrice').textContent=money(p.p);
    $('stickyName').textContent=(p.generic?p.label:p.n+' '+(p.n===1?'Jar':'Jars'))+' · '+productInfo.currency;
    $('topPrice').textContent=money(p.p);
    $('topCompare').textContent=money(base);
    $('topCompare').style.display=base>p.p?'inline':'none';
    $('topDiscount').textContent=discount>0?'Save '+discount+'%':p.available?'Available':'Sold out';
    $('shippingBanner').textContent=p.generic?'Shipping calculated at checkout':freeShipping?'✓ Free shipping unlocked*':'Free shipping on 4+ jars*';
    $('shippingDetail').textContent=p.generic?'Review delivery options at checkout.':freeShipping?'Free shipping for this selected set, subject to checkout eligibility.':'Choose 4, 6 or 10 jars to see free shipping.';
    $('shippingLive').textContent=freeShipping?'Your selected set includes free shipping*':'Current selection: shipping calculated at checkout';
    $('topPrice').animate?.([{transform:'scale(.95)',opacity:.65},{transform:'scale(1.06)',opacity:1},{transform:'scale(1)',opacity:1}],{duration:340,easing:'ease-out'});
  }
  document.querySelectorAll('#aeehfeng-page .choice').forEach(c=>c.addEventListener('click',()=>updatePack(c.dataset.key)));
  // Theme-native PayPal/card controls are rendered by snippets/buy-buttons.liquid.
  // Avoid adding a second direct-checkout workflow here.
  $('aeehfeng-native-quantity')?.addEventListener('change',()=>{const input=$('aeehfeng-native-quantity'); input.value=String(Math.max(1,Math.floor(Number(input.value)||1))); updatePack(selected)});
  $('aeehfeng-native-quantity')?.addEventListener('input',()=>updatePack(selected));
  if(selected)updatePack(selected);
  
  // Keep the native Shopify cart count in sync while using the theme's cart drawer.
  const cartLink=$('aee-header-cart-link');
  const cartCount=$('aee-header-cart-count');
  // Open this theme's *own* Shopify cart-drawer instance.
  // The normal /cart link remains a safe fallback if the drawer cannot be loaded.
  if(cartLink){
    cartLink.addEventListener('click',function(event){
      const nativeDrawer=document.querySelector('cart-drawer');
      if(!nativeDrawer || typeof nativeDrawer.open!=='function')return;
      event.preventDefault();
      nativeDrawer.open(cartLink);
    });
  }
  async function syncAeeCartCount(){
    if(!cartLink||!cartCount)return;
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(!response.ok)return;
      const data=await response.json();
      const count=Math.max(0,Number(data.item_count)||0);
      cartCount.textContent=count>99?'99+':String(count);
      cartCount.hidden=count===0;
      cartLink.setAttribute('aria-label','Shopping cart, '+count+' '+(count===1?'item':'items'));
    }catch(_error){/* The cart link remains available even when Ajax is unavailable. */}
  }
  syncAeeCartCount();
  ['cart:updated','cart:refresh','cart:change','cart:added'].forEach(name=>document.addEventListener(name,syncAeeCartCount));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)syncAeeCartCount()});
  const originalMedia=window.RENOVIIAX_PRODUCT_IMAGES;
  const imageSized=(src,width)=>{const url=new URL(src,window.location.origin);url.searchParams.set('width',String(width));return url.href};
  const galleryView=$('galleryView');
  galleryView.querySelectorAll('.gallery-slide').forEach(el=>el.remove());
  $('galleryThumbs').replaceChildren();
  originalMedia.forEach((src,i)=>{
    const slide=document.createElement('div');slide.className='gallery-slide';slide.setAttribute('role','group');slide.setAttribute('aria-roledescription','slide');slide.setAttribute('aria-label',`${i+1} of ${originalMedia.length}`);
    const picture=document.createElement('div');picture.className='gallery-picture';
    const photo=document.createElement('img');photo.alt=`Aeehfeng product photograph ${i+1}`;photo.loading=i===0?'eager':'lazy';photo.dataset.fullSrc=imageSized(src,900);if(i===0)photo.src=photo.dataset.fullSrc;
    picture.appendChild(photo);slide.appendChild(picture);
    const label=document.createElement('div');label.className='picture-label';
    const name=document.createElement('span');name.textContent=`Product image ${i+1}`;
    const count=document.createElement('small');count.textContent=`${String(i+1).padStart(2,'0')} / ${originalMedia.length}`;
    label.append(name,count);slide.appendChild(label);galleryView.insertBefore(slide,$('galleryCount'));
    const thumb=document.createElement('button');thumb.className='gallery-thumb';thumb.type='button';thumb.dataset.slide=String(i);thumb.setAttribute('role','tab');thumb.setAttribute('aria-selected','false');thumb.setAttribute('aria-label',`Show product image ${i+1}`);
    const mini=document.createElement('img');mini.src=imageSized(src,130);mini.alt='';mini.loading=i<4?'eager':'lazy';thumb.appendChild(mini);$('galleryThumbs').appendChild(thumb);
  });
  const gallerySlides=[...document.querySelectorAll('.gallery-slide')];
  const galleryThumbs=[...document.querySelectorAll('.gallery-thumb')];
  let slideIndex=0,carouselTimer=null,touchX=null;
  function showSlide(next){
    if(!gallerySlides.length){$('galleryCount').textContent='';return}
    slideIndex=(next+gallerySlides.length)%gallerySlides.length;
    gallerySlides.forEach((s,i)=>{const active=i===slideIndex;s.classList.toggle('active',active);s.setAttribute('aria-hidden',active?'false':'true');if(active){const im=s.querySelector('img[data-full-src]');if(im&&!im.getAttribute('src'))im.src=im.dataset.fullSrc}});
    galleryThumbs.forEach((t,i)=>{const active=i===slideIndex;t.classList.toggle('active',active);t.setAttribute('aria-selected',active?'true':'false')});
    $('galleryCount').textContent=String(slideIndex+1).padStart(2,'0')+' / '+String(originalMedia.length).padStart(2,'0');
  }
  function resetAuto(){clearInterval(carouselTimer);if(gallerySlides.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches)carouselTimer=setInterval(()=>{if(!document.hidden)showSlide(slideIndex+1)},5500)}
  function manualSlide(next){showSlide(next);resetAuto()}
  $('galleryPrev').addEventListener('click',()=>manualSlide(slideIndex-1));
  $('galleryNext').addEventListener('click',()=>manualSlide(slideIndex+1));
  galleryThumbs.forEach(t=>t.addEventListener('click',()=>manualSlide(Number(t.dataset.slide))));
  $('galleryView').addEventListener('pointerdown',e=>{touchX=e.clientX});
  $('galleryView').addEventListener('pointerup',e=>{if(touchX===null)return;const dx=e.clientX-touchX;touchX=null;if(Math.abs(dx)>38)manualSlide(slideIndex+(dx<0?1:-1))});
  $('galleryView').addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();manualSlide(slideIndex+1)}if(e.key==='ArrowLeft'){e.preventDefault();manualSlide(slideIndex-1)}});
  $('galleryView').addEventListener('mouseenter',()=>clearInterval(carouselTimer));
  $('galleryView').addEventListener('mouseleave',resetAuto);
  if(selected)updatePack(selected);showSlide(0);resetAuto();
  if('IntersectionObserver' in window){const obs=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target)}}),{threshold:.1});document.querySelectorAll('.reveal').forEach(el=>obs.observe(el))}else document.querySelectorAll('.reveal').forEach(el=>el.classList.add('visible'));

;

/* Presentation-only grouping of the original product-description nodes. */
(() => {
  // Keep the Shopify product description in its original HTML and visual order.
  return;
  const root = document.getElementById('originalDescription');
  if (!root || root.dataset.brandFlow === 'v12') return;

  const chapters = [...root.children].filter(el => el.classList.contains('brand-chapter'));
  if (chapters.length !== 15) return;
  const originalTextNodes = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) originalTextNodes.push([walker.currentNode, walker.currentNode.data]);
  const originalImages = [...root.querySelectorAll('img')];
  const rich = chapters[14];
  const ingredientIntro = rich.querySelector('.source-ingredient-intro');
  const ingredientArea = rich.querySelector('.source-ingredients-area');
  const ingredientBenefits = rich.querySelector('.source-benefits-panel');
  const narrative = rich.querySelector('.source-rich-narrative');
  if (!narrative || !ingredientIntro || !ingredientArea) return;
  const usageCards = [...narrative.querySelectorAll(':scope > .source-usage-card')];
  const mainUsage = usageCards.find(el => el.querySelector('img')) || usageCards.at(-1);
  const storyReviews = narrative.querySelector('.source-story-reviews');

  function node(tag, className, html = '') {
    const element = document.createElement(tag);
    element.className = className;
    if (html) element.innerHTML = html;
    return element;
  }
  function heading(index, eyebrow, title, desc = '') {
    const wrap = node('div', 'v12-section-title');
    wrap.innerHTML = `<div class="v12-section-index"><span>${index}</span><small>${eyebrow}</small></div><h2>${title}</h2>${desc ? `<p>${desc}</p>` : ''}`;
    return wrap;
  }

  const masthead = document.querySelector('#fullDescription > .source-page-heading');
  if (masthead) {
    const chaptersNav = node('nav', 'v12-anchor-nav');
    chaptersNav.setAttribute('aria-label', 'Product content sections');
    chaptersNav.innerHTML = '<a href="#storyOverview">Overview</a><a href="#bodyConcerns">Benefits</a><a href="#ingredients">Ingredients</a><a href="#ritualHowTo">How to use</a><a href="#customerReviews">Reviews</a><a href="#sourceFaq">FAQ</a>';
    masthead.after(chaptersNav);
  }

  const flow = document.createDocumentFragment();

  // 01: One substantial introductory split; all paragraph and list text is untouched.
  const introduction = node('section', 'v12-introduction v12-section');
  introduction.id = 'storyOverview';
  introduction.append(heading('01', 'THE BODY CARE RITUAL', 'A closer look at the cream'));
  const introGrid = node('div', 'v12-intro-grid');
  const introCopy = node('div', 'v12-intro-copy');
  const introVisual = node('div', 'v12-intro-visual');
  const benefitChapter = chapters[6];
  const benefitMedia = benefitChapter.querySelector(':scope > .chapter-media-node');
  if (benefitMedia) introVisual.append(benefitMedia);
  introCopy.append(benefitChapter);
  introGrid.append(introCopy, introVisual);
  introduction.append(introGrid);
  flow.append(introduction);

  // 02: Five original product-use explanations shown as a uniform, scannable grid.
  const concerns = node('section', 'v12-concerns v12-section');
  concerns.id = 'bodyConcerns';
  concerns.append(heading('02', 'PRODUCT BENEFITS', 'Explore the product details', 'Tap any card to read the complete original description.'));
  const concernGrid = node('div', 'v12-concern-grid');
  chapters.slice(9, 14).forEach((chapter, index) => {
    chapter.classList.add('v12-concern-card');
    chapter.dataset.cardNumber = String(index + 1).padStart(2, '0');
    const more = node('button', 'v12-card-toggle', 'Read full description <span aria-hidden="true">+</span>');
    more.type = 'button';
    more.setAttribute('aria-expanded', 'false');
    more.addEventListener('click', () => {
      const open = chapter.classList.toggle('v12-open');
      more.innerHTML = open ? 'Show less <span aria-hidden="true">−</span>' : 'Read full description <span aria-hidden="true">+</span>';
      more.setAttribute('aria-expanded', String(open));
    });
    chapter.append(more);
    concernGrid.append(chapter);
  });
  concerns.append(concernGrid);
  flow.append(concerns);

  // 03: The source's exact six ingredient explanations in three columns.
  const ingredients = node('section', 'v12-ingredients v12-section');
  ingredients.id = 'ingredients';
  ingredients.append(heading('03', 'THE FORMULA', 'Six key ingredients'));
  ingredients.append(ingredientIntro, ingredientArea);
  flow.append(ingredients);

  // 04: Original two-step directions and its accompanying image.
  const routine = node('section', 'v12-routine v12-section');
  routine.id = 'ritualHowTo';
  routine.append(heading('04', 'YOUR ROUTINE', 'How to use'));
  if (mainUsage) {
    mainUsage.querySelectorAll('[id="ritualHowTo"]').forEach(el => el.removeAttribute('id'));
    routine.append(mainUsage);
  }
  flow.append(routine);

  // 05: Four long original reviews plus the two later original photo reviews.
  const reviews = node('section', 'v12-reviews v12-section');
  reviews.id = 'customerReviews';
  reviews.append(heading('05', 'CUSTOMER FEEDBACK', 'Customer experiences'));
  const primaryReviews = chapters[5];
  primaryReviews.removeAttribute('id');
  reviews.append(primaryReviews);
  if (storyReviews) {
    storyReviews.classList.add('v12-review-pair');
    reviews.append(storyReviews);
    storyReviews.querySelectorAll('.source-review-mini-card').forEach(card => {
      const body = card.querySelector('em');
      if (!body || body.textContent.trim().length < 180) return;
      const more = node('button', 'v12-card-toggle', 'Read full review <span aria-hidden="true">+</span>');
      more.type = 'button';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', () => {
        const open = card.classList.toggle('v12-open');
        more.innerHTML = open ? 'Show less <span aria-hidden="true">−</span>' : 'Read full review <span aria-hidden="true">+</span>';
        more.setAttribute('aria-expanded', String(open));
      });
      card.append(more);
    });
  }
  flow.append(reviews);

  // The remaining merchant material is fully preserved and available on demand.
  const archive = node('section', 'v12-additional v12-section');
  const details = node('details', 'v12-detail-drawer');
  const summary = node('summary', '', '<span><small>MORE PRODUCT INFORMATION</small><strong>Read the complete additional product details</strong></span><b aria-hidden="true">+</b>');
  const archivedCopy = node('div', 'v12-archived-copy');
  [chapters[0], chapters[1], chapters[2], chapters[3], chapters[4], chapters[7], chapters[8]].forEach(el => archivedCopy.append(el));
  if (ingredientBenefits) archivedCopy.append(ingredientBenefits);
  // This retains the repeated directions and the original delivery/specification panels.
  archivedCopy.append(rich);
  details.append(summary, archivedCopy);
  archive.append(details);
  flow.append(archive);

  root.replaceChildren(flow);
  root.dataset.brandFlow = 'v12';
  const everyTextPreserved = originalTextNodes.every(([textNode, text]) => root.contains(textNode) && textNode.data === text);
  const everyImagePreserved = originalImages.every(img => root.contains(img));
  root.dataset.allSourceTextPreserved = String(everyTextPreserved);
  root.dataset.allSourceImagesPreserved = String(everyImagePreserved);
  root.dataset.sourceImageCount = String(root.querySelectorAll('img').length);
  if (!everyTextPreserved || !everyImagePreserved) console.error('Original product source node was lost in the page layout.');
})();

